import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '../util/webService'
import {encodeParams, getAction} from '../util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '../components/FlatButton';
import useSnackbar from '../hooks/useSnackbar';
import MyTableHead from '../components/MyTableHead';
import useIndicator from '../hooks/useIndicator';
import Indicator from '../components/Indicator';
import MyDialog from '../components/MyDialog';
import useForm from '../hooks/useForm';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Link, useNavigate } from 'react-router-dom';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '../util/helper';
import useAlert from "@hooks/useAlert";

import { setSchola } from '@redux/actions/scholaAction';

const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const SmstPage = () => {
  console.log('SmstPage rendering...')
  const inputRef = useRef()
  const defUrl = '/smst'
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  

  const fields = [
    {field: 'schoolId', placeholder: '학교ID',    type:'auto', value:'', visible: false, canSrch: false,selList:[]},
    {field: 'id', placeholder: '학기ID',    type:'text', value:-1, visible: true , canSrch: false, selList:[]},
    {field: 'regiStime', placeholder: '수강신청 시작일', type:'date', value:null, visible: true, canSrch: false,selList:[]},
    {field: 'schoolName', placeholder: '학교명',    type:'text', value:'', visible: true, canSrch: true, selList:[]},
    {field: 'companyName', placeholder: '위탁사',    type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'year', placeholder: '년도', type:'year', value:null, visible: true, canSrch: false,selList:[]},
    {field: 'gisu', placeholder: '기수', type:'number', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'selCodeName', placeholder: '선발방식', type:'text', value:'', visible: true, canSrch: false,selList:[]},
    {field: 'regiEtime', placeholder: '수강신청 종료일', type:'date', value:null, visible: true, canSrch: false,selList:[]},
    {field: 'regiFtime', placeholder: '수강신청 확정일', type:'date', value:null, visible: true, canSrch: false,selList:[]},
    {field: 'lectureStime', placeholder: '강좌 시작일', type:'date', value:null, visible: false, canSrch: false,selList:[]},
    {field: 'lectureEtime', placeholder: '강좌 종료일', type:'date', value:null, visible: false, canSrch: false,selList:[]},
  ]
  
  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [record, set_record] = useState(defRecord)
  const [dataList, set_dataList] = useState([])
  
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 50})
  const [fontSize, set_fontSize] = useState(12)
  const termsRef = useRef({})
  const [schoolGroup, set_schoolGroup] = useState([])
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const dispatch = useDispatch()
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const selCodes = codes.filter(r => r.codeGroupId === 'SA07')

  const buttonRef = useRef(null)
  const {alert, renderAlert} = useAlert()

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };

  const fetchSmsts = async() => {
    const url = defUrl
    openIndicator()
    const resp = await WebService.get(url, {
        pageNum:pageInfo.pageNum,
        pageSize:pageInfo.pageSize, 
        terms:JSON.stringify(termsRef.current), 
        orderByRegi: "Y"
    })
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const totalCount = repMessage.totalCount
    set_totalCount(totalCount)
    records.forEach(r => {
      r.isDetail = false
    })

    return records
  }

  const onLoad = async() => {
    const tempList = await fetchSmsts()
    if(!tempList) {
      return
    }

    const schoolMap = new Map(schools.map(s => [s.id, s]))
    tempList.forEach(st => {
      const found = schoolMap.get(st.schoolId)
      if(found) {
        st.schoolName = found.name
        st.school = found 
      }
      st.selCodeName = selCodes.find(r => r.code === st.selCode)?.name?? ''
    })
    set_dataList(tempList)

    // const schoolGroup = tempList.reduce((acc, cur) => {
    //   if(acc[cur.schoolId]) {
    //     acc[cur.schoolId].push(cur)
    //   }
    //   else {
    //     acc[cur.schoolId] = [cur]
    //   }
    //   return acc
    // }, {})

    // set_schoolGroup(schoolGroup)

    // set_dataList(schoolGroup)

  }

  const onDetail = async(id, guardianNum) => {
    set_detailScreen(true)
    dgHandler[1](true)
    
  }

  const onDelete = async(id) => {
    const url = defUrl
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    }
    else {
      openSnackbar(resp.repMessage)
    }
    
  }
  
  const onCreate = () => {
    const now = moment().format(dateFormat)
    const newRecord = {...defRecord, phase:0, regTime: now, uptTime: now, schoolRltnList:[]}
    newRecord.guardian = {}
    newRecord.regiAndLectureList = []
    set_record(newRecord)
    set_detailScreen(true)
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    termsRef.current = {}
  }

  const handleChangePage = (event, newPage) => {
    set_pageInfo({...pageInfo, pageNum: newPage })
  }
  
  const handleChangeRowsPerPage = (event) => {
    
    const pageSize = parseInt(event.target.value, 10)
    set_pageInfo({pageNum:0, pageSize: pageSize})
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  }

  const findCode = (codeGroupId, code) => {
    const found = codes.filter(d => d.codeGroupId === codeGroupId).find(d => d.code === code)
    return found
  }

  const DgContent = () => {
    const onSubmit = async () => {
      const url = `${defUrl}`
      const data = activeRow
      const resp = await WebService.post(url, data)
      if(resp.repCode === 'ack') {
        onLoad()
        handleChange()
        openSnackbar('저장되었습니다.')
      }
      else {
        openSnackbar('에러 발생')
      }
    }

    const validate = () => {}
    const [
      activeRow,
      errors,
      formLoading,
      handleChange,
      handleSubmit, 
     ] = useForm({
      initialValues: {...record}, 
      onSubmit: onSubmit,
      validate: validate,
    });
    const [emailError, setEmailError] = useState('');
    const [passwordState, setPasswordState] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [nameError, setNameError] = useState('');
    const [registerError, setRegisterError] = useState('');
    const [schoolList, set_schoolList] = useState([])

    // const Boxs = styled(Box)`
    //   padding-bottom: 40px !important;
    // `;
    

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    
    return (
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Typography component="h1" variant="h5">
            기본정보
          </Typography>
          <Boxs component="form" noValidate sx={{ mt: 3 }}>
            <FormControl component="fieldset" variant="standard">
              <Grid container spacing={2}>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      if(col.type === 'select') {
                        return(
                          <Grid item xs={3} key={col.field}>
                            <FormControl fullWidth>
                              <InputLabel>{col.placeholder}</InputLabel>
                              <Select
                                required
                                value={activeRow[col.field]}
                                label={activeRow[col.placeholder]}
                                name={col.field}
                                onChange={handleChange}
                                size='small'
                              >
                                {
                                  col.selList.map(l => {
                                    return(
                                      <MenuItem value={l.id}>{l.name}</MenuItem>
                                    )
                                  })
                                }
                              </Select>
                            </FormControl>
                          </Grid>
                        )
                      }
                      else if(col.type === 'auto') {
                        return(
                          <Grid item xs={3} key={col.field}>
                            <Autocomplete
                              disablePortal
                              options={schoolList}
                              name={col.field}
                              value={schools.find(r => r.id === +activeRow[col.field])}
                              onInputChange={async (event, value, reason) => {
                                if(reason === 'input') {
                                  const records = await searchSchool(value)
                                  set_schoolList(records)
                                }
                              }}
                              onChange={(e, v ) => {
                                activeRow[col.field] = v.id
                              }}
                              size='small'
                              getOptionLabel={(option) => option.label}
                              renderInput={(params) => <TextField  {...params} label="학교명" />}
                            />
                          </Grid>
                        )
                      }
                      else if(col.type === 'date') {
                        return(
                          <Grid item xs={3} key={col.field}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'} >
                              <DatePicker
                                label={col.placeholder}
                                name={col.field}
                                value={activeRow[col.field]}
                                inputFormat='YYYY-MM-DD'
                                onChange={(newValue) => {
                                  const dtime =  moment(new Date(newValue))
                                  const d = dtime.format(dateFormat)
                                  activeRow[col.field] = d
                                  handleChange()
                                }}
                                renderInput={(params) => <TextField name={col.field} fullWidth size='small' {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                        )
                      }
                      else if(col.type === 'year') {
                        return(
                          <Grid item xs={3} key={col.field}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'} >
                              <DatePicker
                                views={['year']}
                                label={col.placeholder}
                                name={col.field}
                                value={activeRow[col.field]}
                                inputFormat='YYYY'
                                onChange={(newValue) => {
                                  const d = moment(new Date(newValue)).format('YYYY')
                                  activeRow[col.field] = d
                                  handleChange()
                                }}
                                renderInput={(params) => <TextField name={col.field} fullWidth size='small' {...params} />}
                              />
                            </LocalizationProvider>
                          </Grid>
                        )
                      }
                      else {
                        return(
                          <Grid item xs={3} key={col.field}>
                            <TextField
                              size='small'
                              required
                              fullWidth
                              name={col.field}
                              label={col.placeholder}
                              value={activeRow[col.field]}
                              onChange={handleChange}
                            />
                          </Grid>
                        )
                      }
                      
                    }
                  })
                }
              </Grid>
            </FormControl>
          <FormHelperTexts>{registerError}</FormHelperTexts>
        </Boxs>
        
        
        <Button disabled={true} variant='contained' color='primary' size='small' onClick={onSubmit} sx={{mt: 10}}>저장</Button>
      </Box>
    </Container>
    );
  }
    

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useEffect(() =>{
    const size = window
      .getComputedStyle(inputRef.current, null)
      .getPropertyValue("font-size")

    set_fontSize(size)
  },[])


  const dg_title = '학기 정보'
  const memo_DgContent = useMemo(()=> {return <DgContent />}, [record, detailScreen])
  if(dataList != null) {
    return (
      <div ref={inputRef}>
        <MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler} callback={()=>{set_detailScreen(false)}}/>
        <MyDialog title={dg_title} component={memo_DgContent} dialogHandler={dgHandler}/>
        <div style={{display:'flex',flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
          <Typography component="h1" variant="h5" align={'center'} >
            학기 관리
          </Typography>
        </div>
        <div style={{display:'flex', flexDirection:'row'}}>
          <Button disabled={true} variant='contained' color='primary' size='small' onClick={() => {onCreate()}}>생성</Button>
        </div>
        
        <div style={{paddingTop:20}}>
          <MUITable>
            <MyTableHead >
              <TableRow>
                {
                  fields.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small'>
                          {col.placeholder}
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <br/>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    onChange={(e) => {
                                      termsRef.current[col.field] = e.target.value
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                                  <br/>
                                  <br/>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small'>
                  <br/>
                  <FlatButton ref={buttonRef} size='small' variant='contained' style={{marginRight:5}} color='primary' onClick={onSearch}>검색</FlatButton>
                  {/*<FlatButton size='small' variant='contained'  color='primary' onClick={onClear}>지우기</FlatButton>*/}
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                  dataList.map((row, index) => {
                    return(
                      <TableRow 
                        onClick={()=> {
                          set_selIdx(index)
                          set_record(row)
                        }}
                        onContextMenu={(e) => {
                            dispatch(setSchola(row.school))
                        }}
                      >
                          {
                            fields.filter(r => r.visible).map((col, index2) => {
                              if(col.field === 'regiStime' || col.field === 'regiEtime' || col.field === 'regiFtime' || col.field === 'lectureStime' || col.field ==='lectureEtime') {
                                  return(
                                    <TableCell key={index2} size='small'>
                                      <Typography variant='body2'>  {row[col.field].substr(0, 10)} </Typography>
                                      <Typography variant='body2'>  {row[col.field].substr(11)} </Typography>
                                     
                                    </TableCell>
                                  )
                                }
                                else {
                                  if(col.field === 'schoolName') {
                                    return(
                                      <TableCell key={index2} size='small' onClick={() => {
                                        dispatch(setSchola(row.school))
                                      }}>
                                        <Link to='/manager'>{row[col.field]}</Link>
                                      </TableCell>
                                    )
                                  }
                                  else {
                                    return(
                                      <TableCell key={index2} size='small'>
                                        <Typography variant='body2'>
                                          {row[col.field]}
                                        </Typography>
                                        
                                      </TableCell>
                                    )

                                  }
                                }
                            })
                          }
                          <TableCell size='small'>
                            <FlatButton variant='outlined' size='small'  style={{marginRight:5}} onClick={() => onDetail(row.id)}>보기</FlatButton>
                            {/*<FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>*/}
                          </TableCell>
                        </TableRow>
                    )
                  })
              }
            </TableBody>
            <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100,{ label: 'All', value: -1 }]}
                colSpan={visibleColumns.length + 1}
                count={totalCount}
                rowsPerPage={pageInfo.pageSize}
                page={pageInfo.pageNum}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelDisplayedRows={
                  ({ from, to, count }) => {
                    // return '' + from + '-' + to + ' 개 ' + count
                    return `${from} - ${to} of ${count}`
                  }
                }
                labelRowsPerPage={'페이지당 갯수'}
              />
            </TableRow>
          </TableFooter>
          </MUITable>

           {renderIndicator()}
           {renderAlert()}
            <dg_content />
          </div>
      </div>
    );
  }
}

export default SmstPage
